export enum ExternalLinkNames {
    TRAINING = 'Training',
    RECOGNITION = 'Recognition',
    FLP360 = 'FLP360'
}
